module.exports = __webpack_public_path__ + "static/media/tanushri.5631dac2.jpg";